export const getImageFromS3 = (path) => {
  const sanitizedPath = path.startsWith('/') ? path.slice(1) : path;

  return `${process.env.REACT_APP_BACKEND_URL}/image/${encodeURIComponent(
    sanitizedPath
  )}`;
};
